<template>
  <section v-if="listTripPlans && listTripPlans.length" class="pt-24">
    <h2 class="heading-4-bd mb-20">{{ title }}</h2>
    <div class="scroll-wrapper">
      <div class="scroll-container">
        <div class="scroll-items-section" style="width: 1220px">
          <div class="flex pb-24">
            <TripPlanCard
              v-for="(item, index) in listTripPlans"
              :key="item.id"
              :data="item"
              :order="index + 1"
              style="width: 25%; min-width: 290px"
              class="px-8"
              version="sub"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center pt-20">
      <router-link v-if="!isEmpty(destinationRouteTrip)" :to="destinationRouteTrip" id="view-all-trip" @click="setGallerySource">
        <DJButton type="tertiary"><span class="px-6">View All Trips</span></DJButton>
      </router-link>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue"
import TripPlanCard from './TripPlanCard.vue'
import DJButton from '~/components/ui/button/Button.vue'
import { isEmpty } from '~/helper'
import { useTripPlanStore } from '~/store/pinia/tripPlan'
import { useHeapStore } from '~/store/pinia/heap'

const props = defineProps({
  listTrips: { type: [Object, Array] },
  url: { type: Object, default: () => {} },
  className: { type: String },
  heapSource: { type: String, default: 'suggestion' },
})

const tripPlanStore = useTripPlanStore()
const heapStore = useHeapStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)
const destinationRouteTrip = computed(() => {
  if (isEmpty(dataTrip.value)) return ''
  return dataTrip.value?.suggest_trips?.country_url || ''
})
const listTripPlans = computed(() => {
  if (isEmpty(dataTrip.value)) return []
  return dataTrip.value?.suggest_trips?.items || []
})
const title = computed(() => {
  if (isEmpty(dataTrip.value)) return ''
  const destination = dataTrip.value?.map_note?.destinations || ''
  return destination ? `More Trips in ${destination}` : ''
})

const setGallerySource = async () => {
  await heapStore.changeGalleryHeap(props.heapSource)
}
</script>

<style lang="scss" scoped>
@include scroll-section();
:deep(.scroll-container) {
  padding: 0 16px;
}
</style>
